import classNames from 'classnames';
import React from 'react';
import EfImgVideo from '../ef-img-video';
import './index.scss';

export interface EfSectionLRIconsItemProps {
    icon: React.ReactNode;
    title?: string;
    desc?: string;
}
interface EfSectionLRIconsProps {
    /**
     * 资源链接是否是视频
     */
    isVideo?: boolean;
    /**
     * 所有分辨率展示的资源链接
     */
    pc: string;
    /**
     * 分辨率小于等于1024px展示的资源链接
     */
    h5?: string;
    /**
     * 视频贴图-所有分辨率
     */
    poster?: string;
    /**
     * 视频贴图-分辨率小于等于1024px
     */
    posterH5?: string;

    /**
     * 主标题
     */
    title?: string;
    /**
     * 描述
     */
    desc?: string;
    /**
     * 图片下标题
     */
    imgTitle?: string;
    /**
     * 列表
     */
    list?: EfSectionLRIconsItemProps[];
    /**
     * 图片摆放位置
     */
    position?: 'imgL' | 'imgR';
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护:谢保林
 *
 * 图片 + 图标（左右布局）
 */
const EfSectionLRIcons: React.FC<EfSectionLRIconsProps> = ({ isVideo, pc, h5, poster, posterH5, title, imgTitle, desc, list, position, className }) => {
    const prefixCls = `ef-section-l-r-icons`;
    const hasImg = pc || h5;
    const classes = classNames(prefixCls, 'ef-container', {
        [`${className}`]: className,
        [`${prefixCls}-position-${position}`]: position,
    });

    return (
        <div className={classes}>
            <div className={`${prefixCls}-msg`}>
                <div className={`${prefixCls}-info`}>
                    {title && <h2 className={`${prefixCls}-title`}>{title}</h2>}
                    {desc && <p className={`${prefixCls}-desc`}>{desc}</p>}
                </div>
                <ul className={`${prefixCls}-list`}>
                    {list?.map((item: EfSectionLRIconsItemProps, index: number) => {
                        return (
                            <li className={`${prefixCls}-item`} key={index}>
                                <div className={`${prefixCls}-item-icon`}>{item.icon}</div>
                                <p className={`${prefixCls}-item-title`}>{item.title}</p>
                                {item.desc && <p className={`${prefixCls}-item-desc`}>{item.desc}</p>}
                            </li>
                        );
                    })}
                </ul>
            </div>
            {hasImg && (
                <div className={`${prefixCls}-img`}>
                    <EfImgVideo isVideo={isVideo} pc={pc} h5={h5} poster={poster} posterH5={posterH5} autoPlay={true} loop={true} />
                    {imgTitle && <div className={`${prefixCls}-imgTitle`}>{imgTitle}</div>}
                </div>
            )}
        </div>
    );
};

export default EfSectionLRIcons;
